import { render } from "./ToggleFavouritedButton.vue?vue&type=template&id=16942e70&scoped=true"
import script from "./ToggleFavouritedButton.vue?vue&type=script&lang=js"
export * from "./ToggleFavouritedButton.vue?vue&type=script&lang=js"

import "./ToggleFavouritedButton.vue?vue&type=style&index=0&id=16942e70&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16942e70"]])

export default __exports__